<script lang="ts" setup>
defineProps<{
  title: string
}>()
</script>

<template>
  <a
    class="
      border-stroke-light-800 whitespace-nowrap rounded-[44px] border px-[10px] py-2 text-xs text-main-dark
      !no-underline md:py-1 md:text-sm md:leading-[1.71]
    "
    href="#"
  >
    {{ title }}
  </a>
</template>
